const React = require("react");
const { useParams } = require("react-router-dom");
const { useCJDropshipping } = require("../context/CJDropshippingContext");
const { ProductCollectionPage } = require("../components/ProductCollectionPage");
const h = React.createElement;

const DropshippingSupplierProducts = () => {
  const { supplierId } = useParams();
  const { t } = useCJDropshipping();
  return h(ProductCollectionPage, {
    supplierId,
    title: t("h_cj_supplier_products_title", "Supplier products"),
    description: t("h_cj_supplier_products_desc", "Import selected CJ products into your Elakay shop."),
  });
};

module.exports = { DropshippingSupplierProducts };
